import { render, staticRenderFns } from "./indexNew.vue?vue&type=template&id=44245ca7&scoped=true"
import script from "./indexNew.vue?vue&type=script&lang=js"
export * from "./indexNew.vue?vue&type=script&lang=js"
import style0 from "./indexNew.vue?vue&type=style&index=0&id=44245ca7&lang=scss&scoped=true"
import style1 from "./indexNew.vue?vue&type=style&index=1&id=44245ca7&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44245ca7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44245ca7')) {
      api.createRecord('44245ca7', component.options)
    } else {
      api.reload('44245ca7', component.options)
    }
    module.hot.accept("./indexNew.vue?vue&type=template&id=44245ca7&scoped=true", function () {
      api.rerender('44245ca7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/commercialMap/page/indexNew.vue"
export default component.exports